/**
 * Classes de l'élément racine `.app` : variantes de la maquette retenues
 * (voir styles/logaia-v3.css). Aussi utilisées hors du cadre du dossier (ex. aide de la
 * page de connexion) pour que les fenêtres aient le même rendu.
 */
export const APP_CLASSES = 'app d-clair s-encre sep-barre bg-bandeau mg-sauge ic-rond pp-gris mn-q1';

/**
 * Conteneur `.app` hors du cadre qui ne porte que des fenêtres (aide, mot de passe de la page de connexion) : mêmes
 * classes pour le même rendu des fenêtres, sans la mise en page de `.app` (styles.css, `.app.app-fenetres`).
 */
export const APP_CLASSES_FENETRES = `${APP_CLASSES} app-fenetres`;
